import { Component } from '@angular/core';
import { InactivePopup } from '@d-components/popup/inactive-popup/inactive-popup.component';
import { AppConstant, ModalSize } from '@d-constants';
import {
  AuthService,
  CheckIdleService,
  ModalService,
  RoleService,
} from '@d-services';
import { AuditService } from '@d-services/wms/audit.service';
import { ReferenceDataService } from '@d-services/wms/reference-data.service';
import { updateCurrentPermission } from '@d-store/app-config/app-config.action';
import { getCurrentPermission } from '@d-store/app-config/app-config.selector';
import { AppState } from '@d-store/constant';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'dialog';

  modulePermission$ = this.store.pipe(select(getCurrentPermission));

  constructor(
    public translate: TranslateService,
    private store: Store<AppState>,
    private referenceDataService: ReferenceDataService,
    private modalService: ModalService,
    private checkIdleService: CheckIdleService,
    private auditService: AuditService,
    private authService: AuthService,
  ) {
    translate.addLangs(['en', 'my']);
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnInit(): void {
    this.checkIdleService.startTimer();
    if (this.authService.isLoggedIn()) {
      this.authService.getCurrentUser().subscribe((userInfo) => {
        if (userInfo) {
          this.referenceDataService.getAllCountry().subscribe();
          this.referenceDataService.getAllStates().subscribe();
          this.auditService.createEventLog('OP', 'login');
          this.authService.getCurrentRolePermissions().subscribe((res) => {
            this.store.dispatch(
              updateCurrentPermission({
                modulePermission: res.data.filter(
                  (i) =>
                    i.actions.length && i.moduleCode.startsWith('Subsidy.OP'),
                ),
              }),
            );
          });

          this.checkIdleService.idle$.pipe(take(1)).subscribe(() => {
            this.openInactivePopup();
            this.checkIdleService.stopTimer();
          });
        }
      });
    }
  }

  openInactivePopup() {
    this.auditService.createEventLog('OP', 'logout');
    this.modalService
      .openModal(InactivePopup, {
        title: 'SESSION_EXPIRED',
        size: ModalSize.MEDIUM,
        showIconClose: false,
      })
      .subscribe();
  }

  redirectCallbackUrl() {
    var url = localStorage.getItem('urlCallBack');
    if (url) {
      url = decodeURIComponent(url);
      var originUrl = window.location.origin;
      if (originUrl.indexOf('personalization-setup') == -1) {
        localStorage.removeItem('urlCallBack');
      }
      if (
        url != originUrl &&
        url != originUrl + '/' &&
        url != originUrl + '/#' &&
        url != originUrl + '/#/'
      ) {
        window.location.href = url;
      }
    }
  }
}
